export default function CloseIcon({ fillColor = '#05050D', className = '' }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M12.2401 13.6868L8.00014 9.44014L3.76014 13.6868L2.81348 12.7401L7.06014 8.50014L2.81348 4.26014L3.76014 3.31348L8.00014 7.56014L12.2401 3.32014L13.1801 4.26014L8.94014 8.50014L13.1801 12.7401L12.2401 13.6868Z"
        fill={fillColor}
      />
    </svg>
  );
}
